import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import momentJalaali from 'moment-jalaali'

export default class ShamsiDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: null,
            endDate: null,
            focusedInput: null,
        }

        momentJalaali.loadPersian()

    }



    render() {
        let newdate = new Date();
        let today = momentJalaali(newdate).format("jYYYY-jMM-jDD");
        return (
            <div className="w-100 pt-5 pb-5  calender-jalali">

                <DateRangePicker
                    startDateId='startDate'
                    endDateId='endDate'
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    // isRTL
                    startDatePlaceholderText="تاریخ رفت"
                    endDatePlaceholderText="تاریخ برگشت"

                    renderMonthText={month => momentJalaali(month).format('jMMMM jYYYY')}
                    renderDayContents={day => momentJalaali(day).format('jD')}
                    displayFormat={'YYYY-MM-DD'}
                    hideKeyboardShortcutsPanel={true}
                // keepOpenOnDateSelect={true}
                />
                {this.state.focusedInput != null &&
                    <div className='Today-date-change'>
                        <span className='date-of-today'>
                            امروز : <span>{today}</span>
                        </span>
                        {/* <span className='change-to-persian'>
                            <Button color="secondary" onClick={() => {
                                console.log('555')
                                // this.props.set();
                            }} >Persian Calender</Button>
                        </span> */}
                    </div>
                }
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/Calendar/ShamsiDate.jsx